export const GET_CURRENT_USER_REQUEST = 'app/services/CurrentUser/GET_CURRENT_USER_REQUEST';
export const GET_CURRENT_USER_SUCCESS = 'app/services/CurrentUser/GET_CURRENT_USER_SUCCESS';
export const GET_CURRENT_USER_FAILURE = 'app/services/CurrentUser/GET_CURRENT_USER_FAILURE';

export const actionGetCurrentUserRequest = () => ({
    type: GET_CURRENT_USER_REQUEST,
});

export const actionGetCurrentUserSuccess = (data) => ({
    type: GET_CURRENT_USER_SUCCESS,
    payload: data,
});

export const actionGetCurrentUserFailure = (error) => ({
    type: GET_CURRENT_USER_FAILURE,
    error,
});
